import { useAddressToCheck } from 'hooks/useAddressToCheck';
import { useEffect } from 'react';
import { useCheckAddressSuccessHandler } from 'hooks/useCheckAddressSuccessHandler';
import { useCheckAvailability } from 'hooks/useCheckAvailability';

export const useAutoAddressCheck = () => {
    const handleCheckAddressSuccess = useCheckAddressSuccessHandler();
    const addressToCheck = useAddressToCheck();
    const { checkAvailability, availability, loading, error } = useCheckAvailability();

    useEffect(() => {
        if (addressToCheck) {
            checkAvailability(addressToCheck);
        }
    }, [addressToCheck, checkAvailability]);

    useEffect(() => {
        if (availability) {
            handleCheckAddressSuccess();
        }
    }, [availability, handleCheckAddressSuccess]);

    return {
        loading,
        error,
    };
};
